import { render } from "./DemographicReport.vue?vue&type=template&id=48690017&scoped=true"
import script from "./DemographicReport.vue?vue&type=script&lang=js"
export * from "./DemographicReport.vue?vue&type=script&lang=js"

import "./DemographicReport.vue?vue&type=style&index=0&id=48690017&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48690017"]])

export default __exports__